export const localText = {
  removeGovernorDialogTitle: 'Remove data governor',
  removeGovernorButton: 'Remove governor',
  removalWarningMessage:
    'This change cannot be undone. The service will reject removal of the final governor.',
  confirmRemovalTitle: 'Confirm removal',
  unableToRemoveGovernorTitle: 'Unable to remove governor',
} as const

export function removeGovernorConfirmationText(
  email: string,
  businessObject: string,
  hub: string,
): string {
  return `Remove ${email} from ${businessObject} in ${hub}?`
}
